import { Component, OnInit } from '@angular/core';
import { Canal } from '../../_models/canal';
import { CanalProducto } from '../../_models/canal-producto';
import { CanalRol } from '../../_models/canal-rol';
import { CanalService } from '../../_services/canal.service';
import { ActivatedRoute, Params } from '@angular/router';
import { CanalProductoService } from '../../_services/canal-producto.service';
import { CanalRolService } from '../../_services/canal-rol.service';
import { NavService } from '../../_services/_nav.service';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { EstructuraFisica } from '../../_models/estructura-fisica';
import { Zona } from '../../_models/zona';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { ZonaService } from '../../_services/zona.service';

@Component( {
  selector: 'app-estructura-fisica-detalle',
  templateUrl: 'estructura-fisica-detalle.component.html'
} )

export class EstructuraFisicaDetalleComponent implements OnInit {
  estFisica: EstructuraFisica = new EstructuraFisica();
  zonas: Zona[] = [];
  carInformacionInicial = true;
  columnas: any[];

  constructor( private estFisicaServicio: EstructuraFisicaService,
               private route: ActivatedRoute,
               private zonServicio: ZonaService,
               private navServicio: NavService,
               private location: Location ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'codifo', header: this.navServicio.buscarMensaje( 'ZONES.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'ZONES.LBL_ZONA' ), sort: true },
      { field: 'clasificacionZona', header: this.navServicio.buscarMensaje( 'ZONES.LBL_CLASIFICACION' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'ZONES.LBL_HABILITADO' ), sort: true }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.estFisicaServicio.getById( params[ 'id' ] ),
        this.zonServicio.getAllByEstructuraFisica( params[ 'id' ] )
      ).subscribe( ( [ estFisica, zonas ] ) => {
        this.estFisica = estFisica;
        this.zonas = zonas;
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
